import { useNavigate } from "flemo";
import { LoaderCircleIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/store/authStore";
export function LogoutSection() {
  const { replace } = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useAuthStore(state => state.logout);

  async function handleLogout(): Promise<void> {
    setIsLoggingOut(true);
    try {
      logout();
      replace("/login", {}, { transitionName: "none" });
    } catch {
      toast.error("로그아웃에 실패했어요. 다시 시도해 주세요.", { richColors: true, position: "top-center" });
    } finally {
      setIsLoggingOut(false);
    }
  }

  return (
    <Button
      type="button"
      variant="ghost"
      className="flex w-full items-center justify-end px-4 py-6 text-muted-foreground hover:bg-muted/50 transition-colors disabled:opacity-50 disabled:pointer-events-none cursor-pointer"
      onClick={() => void handleLogout()}
      disabled={isLoggingOut}
    >
      {isLoggingOut && <LoaderCircleIcon className="size-4 animate-spin text-muted-foreground" />}
      로그아웃
    </Button>
  );
}
